import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  initialize() {
    // Modal controller initialized
  }

  connect() {
    // Add event listeners as backup to data-action attributes
    this.element.addEventListener(
      "turbo:submit-end",
      this.submitEnd.bind(this),
    );
    this.element.addEventListener("click", this.onBackgroundClick.bind(this));
  }

  hideModal() {
    // Find the modal turbo frame and clear it gracefully
    const turboFrame = this.element.closest("turbo-frame");
    if (turboFrame && turboFrame.id === "modal") {
      // Fade out before clearing to prevent flash
      this.element.style.opacity = "0";
      this.element.style.transition = "opacity 150ms ease-out";

      setTimeout(() => {
        turboFrame.removeAttribute("src");
        turboFrame.innerHTML = "";
        turboFrame.src = "";
      }, 150);
    }
  }

  submitEnd(event) {
    if (event.detail.success) {
      this.hideModal();
    }
  }

  cancel(event) {
    if (event.target === this.element) {
      this.hideModal();
    }
  }

  onBackgroundClick(event) {
    if (event.target === this.element) {
      this.hideModal();
    }
  }
}
